<template lang="pug">
.modal-card
  header.modal-card-head
    p.modal-card-title(data-qa="modal-header") 
      b(v-t="'sale.edit_service_item_title'")
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  section.modal-card-body(v-if="service")
    .is-flex.is-align-items-center.is-justify-content-space-between
      div
        p.title.is-5
          service-name-view(:value="{service: item.service, option: item.option}")
      div.pl-4
        p.is-size-5.has-text-right
          strong
            currency-view(:value="item.total")
            //currency-view(:value="item.subtotal - item.discount" v-else)
        p.has-text-danger.is-size-6.has-text-right(v-if="item.total !== item.originalTotal")
          span.has-text-strikedout 
            currency-view(:value="item.originalTotal")
    b-collapse.mb-4(:open="false")
      template(#trigger="props" :open="false")
        p.has-text-right.is-size-7
          a(role="button") 
            span.icon(v-if="props.open") 
              i.mdi.mdi-chevron-up
            span.icon(v-else) 
              i.mdi.mdi-chevron-down
            span(v-t="'actions.show_details'")
            
      .py-2  
        table.table.is-striped.is-narrow.is-size-7.is-fullwidth
          tr
            th(v-t="'sale.service_price'")
            td.has-text-right
              currency-view(:value="item.itemPriceBT")
          tr
            th(v-t="'sale.addon_consumables'")
            td.has-text-right
              currency-view(:value="item.addonCost")
          tr
            th(v-t="'sale.included_consumables'")
            td.has-text-right
              currency-view(:value="item.consumableCost" :class="{'has-text-danger': item.consumableCost > item.itemPrice}")
          tr
            th(v-t="'sale.hardcosts_label'")
            td.has-text-right
              currency-view(:value="item.hardcosts")
          //tr
            th(v-t="'sale.commission_base'")
            td.has-text-right
              currency-view(:value="item.commissionBase")
          tr
            th(v-t="'sale.commission'")
            td.has-text-right
              currency-view(:value="item.commission")
          tr
            th(v-t="'sale.discount'")
            td.has-text-right
              currency-view(:value="item.discount")
          tr
            th(v-t="'sale.tax_label'")
            td.has-text-right
              currency-view(:value="item.tax")
          tr
            th(v-t="'sale.total_price'")
            td.has-text-right
              currency-view(:value="item.total")

    .columns.is-mobile.is-multiline
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.initial_price_label')" expanded)
          b-input(v-model="item.price" readonly  expanded data-vv-as="price" name="price" numeric disabled)
          .control
            span.button.is-static 
              currency
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.final_price_label')")
          b-input(v-model.number="item.manualPrice" :disabled="item.discountType" @input="update" expanded  data-vv-as="price" name="price" numeric v-validate="'required|decimal:2|min_value:0'" :use-html5-validation="false")
          .control
            span.button.is-static 
              currency
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.discount_label')")
          DiscountSelect(@input="onDiscountChange" :value="item.discountType" :current-discount="item.discount" :locationId="locationId")
      .column.is-4-desktop.is-6-tablet.is-12-mobile(v-if="service.resources && service.resources.length")
        b-field(:label="$t('sale.resource_label')")
          ResourceSelectDropdown.brand-bordered.is-thin.px-1(
              :resourceId="item.resource"
              :service="service" 
              :locationId="locationId"
              @input="updateResource"
            ) 
    
      .column.is-4-desktop.is-6-tablet.is-12-mobile(v-if="service.staff && service.staff.length")
        b-field(:label="$t('sale.staff_label')")
          StaffSelectDropdown.brand-bordered.is-thin.px-1(
            :staffId="item.staff" 
            :locationId="locationId" 
            :serviceId="item.service" 
            @input="updateStaff") 
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.commission_label')" expanded)
          b-input(:value="formatCurrency(item.commission)" data-vv-as="commission" name="commission" readonly expanded)

          .control
            span.button.is-static  {{item.commissionRate}}%
          
      .column.is-4-desktop.is-6-tablet.is-12-mobile
        b-field(:label="$t('sale.duration_label')")
          duration-input(v-model="item.duration" :undefined-value="false" name="duration" expanded)
    ServiceItemConsumablesEditor(:value="item.consumables" @input="updateConsumables")
    

  footer.modal-card-foot
    .buttons
      action-button(title="actions.save" @click="save")
      button.button.is-outlined(type="button" @click="$emit('close')" ) {{$t('actions.cancel')}}


</template>
<script>
import {mapActions, mapState} from 'vuex'
import saleHelper from '../../../shared/saleHelper'

import SALE_ITEM_TYPES from '../../../constants/saleItemTypes'
// import PRODUCT_TYPES from '../../../constants/productTypes'

import ServiceItemConsumablesEditor from './ServiceItemConsumablesEditor'
// import ProductView from '../inventory/ProductView'
// import ProductUnitLabel from '../inventory/ProductUnitLabel'
// import ProductSelector from '../inventory/ProductSelector'
import StaffSelectDropdown from '../staff/StaffSelectDropdown'
import ResourceSelectDropdown from '../staff/ResourceSelectDropdown'
import CustomerMembershipTagView from '../membership/CustomerMembershipTagView'
import DiscountSelect from '../discounts/DiscountSelect'

export default {
  name: 'ServiceItemEditModal',
  components: {
    StaffSelectDropdown,
    ResourceSelectDropdown,
    CustomerMembershipTagView,
    DiscountSelect,
    ServiceItemConsumablesEditor
  },
  props: {
    value: {type: Object, required: true},
    locationId: {type: String, required: true},
    saleItems: {type: Array, required: true},
    customerCoupon: {type: Object, default: undefined},
    memberships: {type: Array, default: undefined}
  },
  data() {
    return {
      SALE_ITEM_TYPES,
      item: undefined,
      service: undefined
    }
  },

  computed: {
    ...mapState('tax', ['taxesMap']),
    ...mapState('company', ['company']),
    ...mapState('location', ['locationsMap']),
    priceIncludesTax() {
      return this.company.priceIncludesTax
    },

    appliedMembership() {
      return saleHelper.findEligibleMembership({memberships: this.memberships, item: this.item})
    }
  },
  watch: {
    async value(newVal) {
      if (this.item === newVal) {
        return
      }
      this.item = Object.assign({}, newVal)
      await this.init()
      await this.update()
    },
    customerCoupon() {
      this.update()
    },
    memberships() {
      this.update()
    }
  },
  async created() {
    this.item = Object.assign({}, this.value)
    await this.init()
    await this.update()
  },
  methods: {
    ...mapActions('services', ['fetchServiceById']),
    ...mapActions('membershipPackages', ['getMembershipPackageById']),
    ...mapActions('inventory', ['fetchProduct']),
    ...mapActions('staff', ['fetchStaffById']),
    async update() {
      await this.recalculate()
      // this.$emit('input', this.item)
    },
    async init() {
      this.service = await this.fetchServiceById(this.item.service)
    },
    save() {
      this.$emit('input', this.item)

      this.$emit('close')
    },
    async updateConsumables(consumables) {
      this.item.consumables = consumables
      this.update()
    },
    async updateStaff({staffId, preferred}) {
      let currentStaff = this.item.staff
      this.item.staff = staffId
      this.item.preferred = preferred

      if (this.item.type === SALE_ITEM_TYPES.SERVICE) {
        if (!this.service) {
          await this.fetchServiceById(this.item.service)
        }
        let option = this.service.pricingOptions.find(o => o._id === this.item.option)
        const {price} = saleHelper.getPricingOption(option, this.item.staff)
        if (this.item.price !== price) {
          const formattedPrice = saleHelper.formatCurrency(price, this.company.currency)
          const {firstName, lastName} = await this.fetchStaffById(this.item.staff)
          this.$buefy.dialog.confirm({
            title: this.$t('sale.staff_change_price_warning.title'),
            type: 'is-black',
            message: this.$t('sale.staff_change_price_warning.body', {firstName, lastName, price: formattedPrice}),
            cancelText: this.$t('misc.no'),
            confirmText: this.$t('misc.yes'),
            onConfirm: () => {
              this.item.price = price
              this.item.manualPrice = price
              this.item.priceAdjustment = 0
              this.update()
            },
            onCancel: () => {
              this.item.staff = currentStaff
              this.update()
            }
          })
        }
      }
      this.update()
    },
    async updateResource({resourceId, preferredResource}) {
      this.item.resource = resourceId
      this.item.preferredResource = preferredResource
      this.update()
    },
    async recalculate() {
      let taxes = await this.getItemTaxRates()
      let staffMember = this.item.staff && (await this.fetchStaffById(this.item.staff))
      const {commissionRate, commissionBase} = await this.getCommissionCriteria()

      saleHelper.recalculate({
        item: this.item,
        items: this.saleItems,
        taxes,
        priceIncludesTax: this.company.priceIncludesTax,
        customerCoupon: this.customerCoupon,
        commissionRate,
        commissionBase,
        staffMember,
        memberships: this.memberships,
        rewardsEligible: await this.getRewardsEligibility(),
        consumableProductsList: await this.getConsumableProductsList()
      })
    },
    async getConsumableProductsList() {
      if (!this.item.consumables || !this.item.consumables.length) {
        return []
      }
      return Promise.all(this.item.consumables.map(c => this.fetchProduct(c.product)))
    },
    async getRewardsEligibility() {
      if (!this.company.membership.collectFrom || !this.company.membership.collectFrom.includes(this.item.type)) {
        return false
      }

      let service = await this.fetchServiceById(this.item.service)
      return service.collectRewards !== false
    },
    async getCommissionCriteria() {
      let staffMember = this.item.staff && (await this.fetchStaffById(this.item.staff))
      let commissionRate = 0
      let commissionBase = 0
      if (staffMember && staffMember.commission) {
        if (this.item.type === SALE_ITEM_TYPES.SERVICE && staffMember.service) {
          let service = await this.fetchServiceById(this.item.service)
          if (service.commissionRate !== undefined) {
            commissionRate = service.commissionRate
            commissionBase = service.commissionType || staffMember.commission.servicesType
          } else {
            commissionRate = staffMember.commission.services || 0
            commissionBase = staffMember.commission.servicesType
          }
        }
      }

      return {commissionRate, commissionBase}
    },
    async getItemTaxRates() {
      let service = await this.fetchServiceById(this.item.service)
      let taxId = service.taxes && service.taxes[this.locationId]

      if (taxId) {
        let tax = this.taxesMap[taxId]
        let items = (tax.items && tax.items.length && tax.items.map(tId => this.taxesMap[tId])) || [tax]
        return items.map(i => {
          return {rate: i.rate, tax: i._id, name: i.name}
        })
      }
      return []
    },
    onDiscountChange(discount) {
      if (discount) {
        this.item.discountType = discount._id
        this.item.discountRate = discount.value
      } else {
        this.item.discountType = undefined
        this.item.discountRate = undefined
        this.item.manualPrice = this.item.price
      }
      this.update()
    },
    formatCurrency(value) {
      return saleHelper.formatCurrency(value, this.company.currency)
    }
  }
}
</script>
